module.exports = __webpack_public_path__ + "img/Your Wedding Destination.ed315993.jpeg";